import axios from 'axios';
import { attachAuth } from '@/utils/authSession';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "http://localhost:9000/",
  headers: {
    Accept: 'application/json',
  }
});

attachAuth(apiClient);

export default {
  uploadImage(image) {
    return apiClient.post('/upload-image', image, {
      headers: {
        'Content-Type': 'multipart/form-data', 
      }
    });
  },
  attachImageToStatus(image) {
    return apiClient.post('/attachImageToStatus', image, {
      headers: {
        'Content-Type': 'multipart/form-data', 
      }
    });
  },
  getProfileImage(){
    return apiClient.get(`/getProfilePhoto`)
  },
  getProfileImageForComments(username){
    return apiClient.get(`/getProfilePhotoForComments/${username}`)
  },
  
updateProfileImage(userId, publicId, formData) {
  return apiClient.post(`/updateProfilePhoto/${userId}/${publicId}`, formData);
}
}